"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TextBlockWrapper = styled_components_1.default.div.attrs({
    'data-id': `text-block-wrapper`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: 'text.richText',
}), ({ theme }) => theme.text.textBlockWrap || {});
exports.default = TextBlockWrapper;
//# sourceMappingURL=TextBlockWrapper.js.map